import Typography from '@material-ui/core/Typography';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { AiOutlineDoubleRight } from 'react-icons/ai';

const useStyles = makeStyles((theme) => {
  return {
    logoContainer: {
      padding: theme.spacing(2),
      alignItems: 'center',
      flexBasis: theme.layout.drawerWidth,
      backgroundColor: theme.palette.primary.dark,
    },
    logo: {
      color: theme.palette.alternate.main,
    },
  };
});

const Logo = () => {
  const classes = useStyles();

  return (
    <Box display='flex' flexDirection='row' className={ classes.logoContainer }>
      <AiOutlineDoubleRight style={ { margin: '0 4px' } } color='white' fontSize={ 24 } />
      <Typography variant='h6' noWrap>
        <Box className={ classes.logo } fontStyle='italic' fontWeight='fontWeightLight'>
          Admin
          {' '}
          <span style={ { fontWeight: 'normal', fontStyle: 'normal' } }>Board</span>
        </Box>
      </Typography>
    </Box>
  );
};

export default Logo;
